/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free codon usage calculator. Paste a coding DNA/RNA sequence to get each codon's count, frequency per 1000 codons and fraction among synonymous codons.`)
};

const es_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de uso de codones. Pega una secuencia codificante de ADN/ARN para obtener el conteo de cada codón, la frecuencia por 1000 codones y la fracción entre los codones sinónimos.`)
};

const de_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Codon-Nutzungsrechner. Fügen Sie eine kodierende DNA-/RNA-Sequenz ein, um die Anzahl, Häufigkeit pro 1000 Codons und den Anteil jedes Codons unter den synonymen Codons zu erhalten.`)
};

const nl_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis codongebruikcalculator. Plak een coderende DNA-/RNA-sequentie om het aantal, de frequentie per 1000 codons en de fractie tussen synonieme codons van elk codon te krijgen.`)
};

const fr_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit d'usage des codons. Collez une séquence d'ADN/ARN codante pour obtenir le décompte, la fréquence pour 1000 codons et la fraction de chaque codon parmi les codons synonymes.`)
};

const it_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito dell'uso dei codoni. Incolla una sequenza codificante di DNA/RNA per ottenere il conteggio di ciascun codone, la frequenza per 1000 codoni e la frazione tra i codoni sinonimi.`)
};

const pt_br2_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de uso de códons. Cole uma sequência codificante de DNA/RNA para obter a contagem de cada códon, a frequência por 1000 códons e a fração entre os códons sinônimos.`)
};

const pt_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de uso de codões. Cole uma sequência codificante de ADN/ARN para obter a contagem, a frequência por 1000 codões e a fração de cada codão entre os codões sinónimos.`)
};

const ja_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のコドン使用頻度計算ツール。コードDNA/RNA配列を貼り付けると、各コドンのカウント数、1000コドンあたりの頻度、同義コドン間の割合が得られます。`)
};

const zh_codon_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费密码子使用计算器。粘贴编码 DNA/RNA 序列，即可获得每个密码子的计数、每千个密码子的频率，以及在其氨基酸同义密码子中所占的比例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_meta_description", locale)
	if (locale === "en") return en_codon_meta_description(inputs)
	if (locale === "es") return es_codon_meta_description(inputs)
	if (locale === "de") return de_codon_meta_description(inputs)
	if (locale === "nl") return nl_codon_meta_description(inputs)
	if (locale === "fr") return fr_codon_meta_description(inputs)
	if (locale === "it") return it_codon_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_codon_meta_description(inputs)
	if (locale === "pt") return pt_codon_meta_description(inputs)
	if (locale === "ja") return ja_codon_meta_description(inputs)
	return zh_codon_meta_description(inputs)
};